module.exports = __webpack_public_path__ + "img/lg_ring_y_e_0_null@2x.4e84520c.png";